import store from 'redux/store';
import { updateLectureComponentFromAngular } from 'redux/actions/lecture-components';
import { useAngularPreventLecturePageNavigation } from '../hooks/use-prevent-lecture-page-navigation';

/* @ngInject */
export default function IndividualVideoEditController(
  nvUtil,
  $scope,
  $stateParams,
  $timeout,
  $uibModalInstance,
  $window,
  AlertMessages,
  ConfirmationOverlays,
  CurrentCourseManager,
  StateManager,
  S3NameSpaces,
  S3UploadFactory,
  Upload,
  _,
  config,
  lectureVideo,
) {
  const vm = this;

  vm.lectureVideo = lectureVideo;
  vm.videoDraft = _.clone(lectureVideo.video);
  vm.CurrentCourseManager = CurrentCourseManager;
  vm.attachment = {};
  vm.config = config;
  vm.fileMaxSize = `${config.files.rteFileSizeLimit}MB`;
  vm.thumbnailMaxSize = `${config.files.smallFileSizeLimit}MB`;
  let dismissedByUser = false;

  const allowedFileTypes = {
    slides: vm.config.files.rte.presentations.extensions,
    textTranscript: vm.config.files.rte.documents.extensions,
    transcript: vm.config.files.subtitles.split(','),
    customThumbnail: vm.config.files.rte.images.extensions,
  };

  vm.customThumbnailError = function () {
    if (vm.videoEditForm.$invalid && vm.videoEditForm.$error && Object.keys(vm.videoEditForm.$error).length === 1) {
      vm.videoEditForm.$setPristine();
    }
  };

  vm.saveFile = function ($file, type) {
    let extension;
    if ($file.name.includes('.')) {
      extension = _.last($file.name.split('.'));

      if (!_.contains(allowedFileTypes[type], `.${extension.toLowerCase()}`)) {
        vm.videoEditForm.$dirty = false;
        $timeout(() => {
          AlertMessages.error('FORM.OOPS', 'FILE_UPLOAD.NOT_SUPPORTED_ALERT');
        });
        vm.videoDraft[type] = null;
        vm.videoDraft[`${type}FileName`] = null;
      } else {
        vm.videoDraft[type] = $file;
        vm.videoEditForm.$setDirty();
      }
    }
  };

  vm.onDelete = function (type, attr) {
    if (vm.videoDraft[`${type}Url`]) { // if file was saved
      vm.videoDraft[attr] = true;
    }
    vm.videoDraft[type] = null;
    vm.videoDraft[`${type}FileName`] = null;

    vm.videoEditForm.$setDirty();
  };

  vm.updateSingleVideo = function (video) {
    const update = () => {
      vm.uploadInProgress = true;
      const payload = {};
      ['id', 'name', 'canDownload', 'uniqueId', 'fileName', 'slides', 'transcript', 'textTranscript', 'customThumbnail', 'removeSlides',
        'removeTranscript', 'removeTextTranscript', 'removeCustomThumbnail', 'numCoursesUsing', 'recentCoursesUsing'].forEach(key => {
        payload[nvUtil.toSnakeCase(key)] = video[key];
      });
      return Upload.upload({
        url: `${$stateParams.catalogId}/videos/${video.id}`,
        method: 'PUT',
        fields: {
          video: payload,
        },
      }).then((response) => {
        Object.assign(vm.lectureVideo.video, response.data.result);
        if (vm.lectureVideo.videoList.defaultTitle) {
          vm.lectureVideo.videoList.content = vm.lectureVideo.video.name;
        }

        store.dispatch(updateLectureComponentFromAngular({
          lectureVideos: [{
            id: vm.lectureVideo.id,
            video: response.data.result,
          }],
        }));

        dismissedByUser = true;
        $uibModalInstance.close();
      }, (response) => {
        // error handling
        vm.uploadInProgress = false;
      });
    };
    if (video.numCoursesUsing > 1) {
      const courses = video.recentCoursesUsing.filter((course) => course.catalogId !== vm.CurrentCourseManager.course.catalogId).slice(0, 3);
      ConfirmationOverlays.openConfirmationModal('lecture_pages/templates/components/edit-shared-audio-video-confirmation-overlay.html', 'AttachModalResolvesToVmCtrl', {
        vmResolves() {
          return {
            courses,
            isAudio: video.type === 'Audio',
            isProgram: vm.CurrentCourseManager.course.isProgram,
            numCoursesUsing: video.numCoursesUsing - 1,
            numOthers: video.numCoursesUsing - courses.length - 1,
          };
        },
      }).result.then(update);
    } else {
      update();
    }
  };

  vm.uploadFile = ($file, $invalidFiles) => {
    if ($invalidFiles?.length) {
      if ($invalidFiles[0].$error === 'maxSize') {
        AlertMessages.error('FORM.OOPS', 'FILE_UPLOAD.SIZE_EXCEEDED_ALERT', {}, { sizeLimit: $invalidFiles[0].$errorParam });
      } else {
        AlertMessages.error('FORM.OOPS', 'FILE_UPLOAD.NOT_SUPPORTED_ALERT');
      }
    } else if ($file) {
      let extension; let
        valid = true;

      if ($file.name.includes('.')) {
        extension = _.last($file.name.split('.'));

        if (!_.contains(vm.lectureVideo.videoList.constructor.allowedFileTypes, `.${extension.toLowerCase()}`)) {
          $timeout(() => {
            AlertMessages.error('FORM.OOPS', 'FILE_UPLOAD.NOT_SUPPORTED_ALERT');
          });
          valid = false;
        }
      }

      if (valid && $file.size > config.files.videoFileSizeLimitGb * 1024 * 1024 * 1024) {
        $timeout(() => {
          AlertMessages.error('FORM.OOPS', 'FILE_UPLOAD.SIZE_EXCEEDED_ALERT', {}, { sizeLimit: $file.$errorParam });
        });
        valid = false;
      }

      if (valid) {
        uploadVideoFile($file);
      }
    }
  };

  function uploadVideoFile(file) {
    vm.videoEditForm.$setDirty();
    vm.newVideoS3UploadObj = S3UploadFactory.uploadToS3(file, S3NameSpaces.VIDEOS, true);

    vm.newVideoS3UploadObj.promise.then((response) => {
      _.extend(vm.videoDraft, response.config.data.file);
      _.extend(vm.videoDraft, { fileName: response.config.data.file.name });
      // eslint-disable-next-line no-useless-escape
      vm.videoDraft.name = vm.videoDraft.name.replace(/\.[^\/.]+$/, '');
    }, (response) => {
    });
  }

  function hasUnsavedChanges() {
    return vm.videoEditForm?.$dirty;
  }

  const checkUnsavedChanges = () => hasUnsavedChanges();

  useAngularPreventLecturePageNavigation($scope, checkUnsavedChanges);

  // warn if leaving the modal and have unsaved changes
  vm.deregisterStateChangeStart = StateManager.registerStateChangeStart(checkUnsavedChanges,
    'discussions/templates/nv-unsaved-changes-confirmation-overlay.html',
    'FORM.NAVIGATE_AWAY.CLOSE_WINDOW',
    undefined,
    undefined,
    () => {
      vm.deregisterModalClosing?.();
      $uibModalInstance.dismiss();
    });

  vm.deregisterModalClosing = $scope.$on('modal.closing', ($event) => {
    if (hasUnsavedChanges() && !dismissedByUser) {
      $event.preventDefault();

      const modalOverlay = ConfirmationOverlays.openConfirmationModal('discussions/templates/nv-unsaved-changes-confirmation-overlay.html');

      modalOverlay.result.then(() => {
        dismissedByUser = true;
        $uibModalInstance.dismiss();
      });
    }
  });

  $scope.$on('$destroy', () => {
    angular.element($window).off('beforeunload');
    vm.deregisterStateChangeStart?.();
  });
}
